<template>
  <div class="retransmission">
    <div class="selectionArea">
      <el-select v-model="parameter.platform_id" placeholder="请选择平台" style="margin-right: 10px;">
        <el-option
          v-for="item in platforms"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>

      <el-input v-model="parameter.app_name" placeholder="请输入公众号名称" style="margin-right: 10px; width:200px;" />

      <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      <el-button type="primary" icon="el-icon-refresh-right" @click="reset">重置</el-button>
      <el-button type="primary" icon="el-icon-circle-plus" style="position: absolute; right: 40px;" @click="dialogVisible = true">创建</el-button>
    </div>
    <div class="mainArea">
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="type_str"
          label="类型"
          width="100"
          fixed
          align="center"
        />
        <el-table-column
          prop="app_name"
          label="公众号名称/推广链id"
          width="180"
          align="center"
        >
          <template scope="scope">
            {{ scope.row.order_type === 1 ? scope.row.app_name : scope.row.app_id }}
          </template>
        </el-table-column>
        <el-table-column
          prop="order_name"
          label="订单类型"
          width="180"
          align="center"
        />
        <el-table-column
          prop="platform_id"
          label="平台"
          width="180"
          align="center"
        >
          <template scope="scope">
            {{ getPlat(scope.row.platform_id) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="current_num"
          label="当前数量"
          width="100"
          align="center"
        />
        <el-table-column
          prop="callback_full"
          label="满单量"
          width="100"
          align="center"
        />
        <el-table-column
          prop="callback_not"
          label="漏单量"
          width="100"
          align="center"
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
          align="center"
        />
        <el-table-column
          prop="address"
          align="center"
          label="操作"
        >
          <template scope="scope">
            <el-button type="primary" size="mini" @click="(currentlySelected = scope.row),(dialogVisible = true)">修改</el-button>
            <el-button type="warning" size="mini" @click="myDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <PaginationRight
        :total="tableData.count"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>

    <el-dialog
      :title="currentlySelected ? '修改回传策略' : '创建回传策略'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="30%"
      @closed="closePopup"
    >
      <Details v-if="dialogVisible" :current-item="currentlySelected" :platforms="platforms" @determine="determine" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getPlatform } from '@/api/releaseGroup.js'
import { echoConfigurationList, createEchoPolicy, modifyTheReturnPolicy, deleteTheReturnPolicy } from '@/api/returnPolicyList.js'
import Details from './components/details.vue'
export default {
  components: {
    PaginationRight,
    Details
  },
  data() {
    return {
      parameter: {
        platform_id: null, // 平台
        app_name: null, // 公众号
        page: 1, // 当前页
        page_size: 10 // 每页数据量
      },
      dialogVisible: false,
      loading: false,
      platforms: [],
      tableData: {},
      currentlySelected: undefined // 当前选中的项
    }
  },
  created() {
    this.getPlatform()
    this.getListData()
  },
  methods: {

    // 获取对应平台
    getPlat(platform_id) {
      const item = this.platforms.filter(itemm => +itemm.id === +platform_id)[0]
      return item && item.name
    },

    // 分页
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getListData()
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getListData()
    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.platforms.page_size = 10
      this.getListData()
    },

    // 重置
    reset() {
      this.parameter.page = 1
      this.parameter.page_size = 10
      this.parameter.platform_id = null
      this.parameter.app_name = null
      this.getListData()
    },

    // 获取平台
    async getPlatform() {
      const data = await getPlatform()
      this.platforms = data.data.list
    },

    // 获取数据列表
    async getListData() {
      this.loading = true
      try {
        const data = await echoConfigurationList(this.parameter)
        let order_name = ''
        for (let i = 0; i < data.data.list.length; i++) {
          order_name = data.data.list[i].order_type === 1 ? '公众号' : '快应用'
          data.data.list[i]['order_name'] = order_name
        }
        this.tableData = data.data
      } catch (err) {
        this.$message.error(err)
      }
      this.loading = false
    },

    // 关闭弹窗
    closePopup() {
      this.dialogVisible = false
      this.currentlySelected = undefined
    },

    // 确定
    async determine(form) {
      const bool = this.judge(form)
      if (bool) {
        return
      }

      try {
        this.currentlySelected ? await modifyTheReturnPolicy({ ...form, id: this.currentlySelected.id }) : await createEchoPolicy(form)
        this.$message.success(this.currentlySelected ? '更新成功' : '创建成功')
        this.getListData()
        this.closePopup()
      } catch (err) {
        this.$message.error(err)
      }
    },

    // 判断
    judge(form) {
      let text = null
      if (!form.platform_id) {
        text = '请选择平台'
      }
      if (!form.type) {
        text = '请选择类型'
      }
      if (!form.callback_full) {
        text = '请输入满单量'
      }
      if (!form.callback_not) {
        text = '请输入漏单量'
      }

      if ((+form.callback_full <= 0) || (+form.callback_full < +form.callback_not)) {
        text = +form.callback_full <= 0 ? '满单量必须大于0' : '满单量必须大于漏单量'
      }
      if ((+form.callback_not <= 0) || (+form.callback_not > +form.callback_full)) {
        text = +form.callback_not <= 0 ? '漏单量必须大于0' : '漏单量必须小于满单量'
      }

      if (!form.app_name) {
        text = form.order_type === 1 ? '请选择公众号' : '请填写应用名称'
      }
      if (!form.app_id) {
        text = form.order_type === 1 ? '请选择公众号' : '请填写推广链id'
      }
      text && this.$message.warning(text)
      return text
    },

    // 删除
    async myDelete(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          await deleteTheReturnPolicy({ id })
          this.getListData()
          this.$message.success('删除成功')
        } catch (err) {
          this.$message.error(err)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.retransmission{
   width: 95%;
   margin: 0 auto;
   margin-top: 30px;
}
.selectionArea{
    display: flex;
}

.mainArea{
   margin-top: 30px;
}
</style>
